import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';
import { AddRunner } from '@/features/races/AddRunner';
import { PageHeader } from "@/components/layout/PageHeader.tsx";
import { Page } from "@/components/layout/Page.tsx";

export function AddRunnerPage() {
    const { id } = useParams<{ id: string }>();
    const { t } = useTranslation('races');
    const navigate = useNavigate();
    const location = useLocation();
    const fromCreation = location.state?.fromCreation === true;

    if (!id) return null;

    return (
        <Page>
            <PageHeader
                title={t('addRunner.title')}
                backLink={`/races/${id}`}
                width="narrow"
                actions={fromCreation ? (
                    <button
                        onClick={() => navigate(`/races/${id}`, { replace: true })}
                        className="flex items-center gap-1.5 px-4 py-2 rounded-xl bg-emerald-600 text-white text-sm font-bold hover:bg-emerald-700 transition-all active:scale-95"
                    >
                        <Check size={16} />
                        {t('addRunner.finish')}
                    </button>
                ) : undefined}
            />

            <AddRunner raceId={id} />
        </Page>
    );
}
